export default "__VITE_ASSET__BicyVoUH__"